import moment from "moment";

export const getFileExtension = (url) => {
  // Get the last part of the URL after the last '/'
  const filename = url.substring(url.lastIndexOf('/') + 1);

  // Get the file extension by getting the last part of the filename after the last '.'
  const extension = filename.substring(filename.lastIndexOf('.') + 1);

  return extension;
};

export const isObjectEmpty = (obj) => {
  for (const key in obj) {
    if (obj[key]) {

      if (obj[key] === '{"min":0,"max":20000000}') {

      } else {
        return false;
      }

    }
  }
  return true;
}

export function formatDate(date) {
  const now = moment();
  const inputDate = moment(date);

  if (now.isSame(inputDate, 'day')) {
    return 'Today, ' + inputDate.format('hh:mm A');
  } else if (now.subtract(1, 'day').isSame(inputDate, 'day')) {
    return 'Yesterday, ' + inputDate.format('hh:mm A');
  } else {
    return inputDate.format('DD/MM/YYYY, hh:mm A');
  }
}

export function formatPhone(countryCode, phoneNumber) {

  const numericPhoneNumber = phoneNumber.replace(/\D/g, '');
  if (countryCode && numericPhoneNumber) {
    const groups = numericPhoneNumber.match(/(\d{2})(\d{3})(\d{3})(\d+)/);
    if (groups) {
      return `+${countryCode}-${groups[1]}-${groups[2]}-${groups[3]}-${groups[4]}`;
    }
  }
  return phoneNumber;
}


export const capitalize = (str) => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const removeNullValues = (obj) => {
  for (const key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    } 
  }
  return obj
}



export const handleAttr = (
  stAtt,
  attributes
) => {
  let mappedAttributes = [];
  return (mappedAttributes = Object.keys(stAtt)?.reduce((acc, key) => {
    let attribute = attributes?.find((attr) => {return attr?.name === key;});
    const value = stAtt[key];

    let ar_value;
    if (Array.isArray(value)) {
      ar_value = value.map((val) => {
        const option = attribute?.values?.find((item) => item?.name === val);
        return option?.ar_name || val;
      });
    } else {
      ar_value = attribute?.values?.find((item) => item?.name === value)?.ar_name ||  value;
    }

    if (!attribute) {
      return acc;
    }

    acc.push({
      name: key,
      value: value,
      type: attribute?.type,
      attr_id: attribute?._id,
    });

    return acc;
  }, []));
};


export const ChangeLogAction = [
  {name : "ADD" , value : "add"},
  {name : "UPDATE" , value : "update"},
  {name : "DELETE" , value : "DELETE"},
  {name : "STATUS" , value : "STATUS"},

];

export const challengeDuration = [
  {name : "30 Days" , value : 30},
  {name : "60 Days" , value : 60},
  {name : "90 Days" , value : 90},

];


export const challengeCategory = [
  {name : "Mind" , value : "mind"},
  {name : "Body" , value : "body"},
  {name : "Spirit" , value : "spirit"},
  {name : "Seasonal" , value : "seasonal"},
];

